import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NavController } from "@ionic/angular";

@Component({
    selector: "whole-screen-notification-component",
    templateUrl: "./whole-screen-notification-component.component.html",
    styleUrls: ["./whole-screen-notification-component.component.scss"]
})
export class WholeScreenNotificationComponent implements OnInit {
    @Input() title: string;
    @Input() text: string;
    @Input() buttonText: string;
    @Input() image: string;
    @Output() buttonClicked = new EventEmitter();
    @Output() closeButtonClicked = new EventEmitter();

    constructor(private navController: NavController) {}

    ngOnInit() {}

    closeButtonClick() {
        this.closeButtonClicked.emit();
    }

    buttonClick() {
        this.buttonClicked.emit();
    }
}
